import { render, staticRenderFns } from "./CharacterMatchImage.vue?vue&type=template&id=a0ab9eba&"
import script from "./CharacterMatchImage.vue?vue&type=script&lang=js&"
export * from "./CharacterMatchImage.vue?vue&type=script&lang=js&"
import style0 from "./CharacterMatchImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports